export const EMPTY_DELIVERY_ORDERS = {
  new_orders: [],
  accepted_orders: [],
  pickedup_orders: [],
  is_in_limit: true,
  cash_limit: 0,
  delivery_collection: 0,
};
